import React, { FC } from 'react';
import { Select } from '@workboard/wobo-ui';
import { getTimeUnitLabel, TimeUnit } from './model';
import { useSelectEnumField } from '../form/useSelectEnumField';
import { useTranslation } from 'react-i18next';

interface IProps {
  name: string;
  'data-testid'?: string;
  isDisabled?: boolean;
  helperText?: string;
  isError?: boolean;
  label?: string;
  id?: string;
  onChange(e: React.ChangeEvent, obj: unknown): void;
  value?: TimeUnit;
}

export const TimeUnitField: FC<IProps> = ({
  name,
  onChange,
  value,
  ...props
}) => {
  const { t } = useTranslation();
  const customProps = useSelectEnumField(TimeUnit, name, value, onChange);
  return (
    <Select
      {...props}
      getOptionLabel={(opt) => getTimeUnitLabel(opt.value, t)}
      name={name}
      {...customProps}
    />
  );
};
